import { TileEmbedDetail } from './TileEmbedDetail';

export class TilesEmbedDetail {
  tileDetails: TileEmbedDetail[];
}

export default TilesEmbedDetail;